import { useEffect, useState } from "react";
import { UnexpectedErrorFallback } from "../AppErrorBoundary";

export const SHOW_UNEXPECTED_ERROR_EVENT = "showUnexpectedError";

export type UnexpectedErrorDetail = {
  message?: string;
};

/**
 * Full-page unexpected error box for non-business failures (e.g. HTTP 5xx),
 * triggered via {@link SHOW_UNEXPECTED_ERROR_EVENT}.
 */
export default function UnexpectedErrorHost() {
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<UnexpectedErrorDetail>).detail || {};
      setError(new Error(detail.message || "Unexpected error"));
    };
    window.addEventListener(SHOW_UNEXPECTED_ERROR_EVENT, handler);
    return () => window.removeEventListener(SHOW_UNEXPECTED_ERROR_EVENT, handler);
  }, []);

  if (!error) return null;

  return (
    <BoxPortal>
      <UnexpectedErrorFallback error={error} onReset={() => setError(null)} />
    </BoxPortal>
  );
}

function BoxPortal({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1400,
        background: "var(--mui-palette-background-default, #fff)",
        overflow: "auto",
      }}
    >
      {children}
    </div>
  );
}
